import { Col, Container, Image, Row } from "react-bootstrap";
import logo from "../../assets/images/Qompas-logo.png"; // Assuming you might have a white logo or use filter
import { BsFacebook, BsInstagram, BsTwitter, BsGeoAlt, BsEnvelope, BsPhone } from "react-icons/bs";

function Footer() {
  return (
    <footer id="contact" className="pt-5 border-top" style={{ backgroundColor: 'var(--dark-bg)', color: 'var(--text-light)' }}>
      <Container className="pb-5">
        <Row className="gy-5">
          <Col md={4} lg={5}>
            <div className="pe-lg-5">
              {/* Filter logo to be white if it's dark text, or use a new asset if available. For now, filter brightness */}
              <Image src={logo} alt="Logo" height={40} className="mb-4" style={{ filter: 'brightness(10) grayscale(100%)' }} />
              <p className="text-secondary mb-4" style={{ color: '#94a3b8' }}>
                Our crowdfunding platform is a dynamic ecosystem that
                fosters collaboration, innovation, and community engagement.
                Reimagining the landscape to empower creators and backers.
              </p>
              <div className="d-flex gap-3">
                <a href="https://www.facebook.com/gnxtltd?mibextid=LQQJ4d" className="text-light hover-primary transition-colors">
                  <BsFacebook size={24} style={{ color: 'var(--secondary-color)' }} />
                </a>
                <a href="#" className="text-light hover-primary transition-colors">
                  <BsTwitter size={24} style={{ color: 'var(--secondary-color)' }} />
                </a>
                <a href="https://instagram.com/qompas_hq?igshid=MzRlODBiNWFlZA==" className="text-light hover-primary transition-colors">
                  <BsInstagram size={24} style={{ color: 'var(--secondary-color)' }} />
                </a>
              </div>
            </div>
          </Col>
          <Col md={4} lg={3}>
            <h5 className="fw-bold mb-4 text-white">Contact Us</h5>
            <ul className="list-unstyled text-secondary" style={{ color: '#94a3b8' }}>
              <li className="d-flex mb-3">
                <BsGeoAlt className="mt-1 me-3 flex-shrink-0" style={{ color: 'var(--accent-color)' }} />
                <span>26 SA Agada , Dawaki, FCT Abuja</span>
              </li>
              <li className="d-flex mb-3">
                <BsEnvelope className="mt-1 me-3 flex-shrink-0" style={{ color: 'var(--accent-color)' }} />
                <a href="mailto:Qompasvest@gmail.com" className="text-decoration-none hover-primary" style={{ color: '#94a3b8' }}>
                  Qompasvest@gmail.com
                </a>
              </li>
              <li className="d-flex mb-3">
                <BsPhone className="mt-1 me-3 flex-shrink-0" style={{ color: 'var(--accent-color)' }} />
                <a href="tel:07038710878" className="text-decoration-none hover-primary" style={{ color: '#94a3b8' }}>
                  07038710878
                </a>
              </li>
            </ul>
          </Col>
          <Col md={4} lg={4}>
            <h5 className="fw-bold mb-4 text-white">Newsletter</h5>
            <p className="text-secondary mb-3" style={{ color: '#94a3b8' }}>Subscribe to get the latest updates.</p>
            <div className="input-group mb-3">
              <input type="text" className="form-control border-0" placeholder="Enter email address" aria-label="Enter email address" style={{ background: 'rgba(255,255,255,0.1)', color: 'white' }} />
              <button className="btn btn-primary-custom rounded-end" type="button" style={{ background: 'var(--secondary-color)', border: 'none' }}>Subscribe</button>
            </div>
          </Col>
        </Row>
      </Container>
      <div className="py-4 border-top text-center" style={{ borderColor: 'rgba(255,255,255,0.1)', backgroundColor: '#020617' }}>
        <Container>
          <small className="text-secondary" style={{ color: '#64748b' }}>
            Copyright © {new Date().getFullYear()} Qompas. All Rights Reserved
          </small>
        </Container>
      </div>
    </footer>
  );
}
export default Footer;
